var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { column: "" } },
    [
      _c(
        "v-card",
        [
          _c(
            "v-master-detail-pane",
            [
              _c(
                "template",
                { slot: "master" },
                [
                  _c("v-load-nav-list", {
                    attrs: {
                      title: "Deliveries",
                      searchPrompt: "Search Completed Load Transactions",
                      customGroupIcon: "check_circle",
                      groupedItems: _vm.deliveredLoadOpenInvoices,
                      loading: _vm.loadingTransactions,
                      accurateSince: _vm.accurateSince,
                      loads: _vm.invoices,
                      company: _vm.company
                    },
                    on: {
                      "update:searchTerm": function($event) {
                        _vm.search = $event
                      },
                      refresh: function($event) {
                        return _vm.loadCompanyTransactions(_vm.company.id)
                      }
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "loadTile",
                        fn: function(ref) {
                          var idx = ref.idx
                          var txn = ref.load
                          return [
                            _c(
                              "v-list-tile",
                              {
                                key: "load_txn_" + idx + "_" + txn.id,
                                class: {
                                  "primary lighten-1": _vm.isSelectedLoad(txn)
                                },
                                attrs: {
                                  inactive: _vm.isSelectedLoad(txn),
                                  ripple: "",
                                  avatar: ""
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.selectLoad(txn)
                                  }
                                }
                              },
                              [
                                _c(
                                  "v-list-tile-content",
                                  [
                                    _c("v-list-tile-title", [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.loadGroupSponsorName(
                                              txn.load.tacticalInfo.loadGroup
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm.bookedLoadNickname(txn.load)
                                      ? _c(
                                          "v-list-tile-sub-title",
                                          { staticClass: "text--primary" },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.bookedLoadNickname(
                                                    txn.load
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "v-list-tile-sub-title",
                                      { staticClass: "text--primary" },
                                      [
                                        txn.load.pickup
                                          ? _c("span", [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm._f("formatTxDate")(
                                                      txn.load.pickup.when
                                                    )
                                                  ) +
                                                  "\n                    "
                                              )
                                            ])
                                          : txn.load.tacticalInfo
                                              .scheduledPickupTime
                                          ? _c("span", [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    "txn.load.tacticalInfo.scheduledPickupTime | formatTxDate"
                                                  ) +
                                                  "\n                    "
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("v-list-tile-sub-title", [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(txn.loadHumanId) +
                                          ": $" +
                                          _vm._s(txn.amount) +
                                          " (" +
                                          _vm._s(txn.status || "[status]") +
                                          ")\n                "
                                      )
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-list-tile-action",
                                  [
                                    _c(
                                      "v-chip",
                                      {
                                        attrs: {
                                          color: _vm.invoiceStatusIcon(txn)
                                            .color,
                                          "text-color": "white",
                                          small: ""
                                        }
                                      },
                                      [
                                        _c("v-icon", [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.invoiceStatusIcon(txn).icon
                                              ) +
                                              "\n                  "
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("v-divider", {
                              key: "load_txn_divider_" + idx + "_" + txn.id
                            })
                          ]
                        }
                      },
                      {
                        key: "groupedItemsTile",
                        fn: function(ref) {
                          var iidx = ref.idx
                          var status = ref.item
                          var txns = ref.items
                          return [
                            _vm._l(txns, function(txn, idx) {
                              return [
                                _c(
                                  "v-list-tile",
                                  {
                                    key:
                                      "delivered_load_txn_" +
                                      iidx +
                                      "_" +
                                      idx +
                                      "_" +
                                      txn.id,
                                    class: {
                                      "primary lighten-1": _vm.isSelectedLoad(
                                        txn
                                      )
                                    },
                                    attrs: {
                                      inactive: _vm.isSelectedLoad(txn),
                                      ripple: "",
                                      avatar: ""
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.selectLoad(txn)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-list-tile-content",
                                      [
                                        _c("v-list-tile-title", [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.loadGroupSponsorName(
                                                  txn.load.tacticalInfo
                                                    .loadGroup
                                                )
                                              ) +
                                              "\n                  "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _vm.bookedLoadNickname(txn.load)
                                          ? _c(
                                              "v-list-tile-sub-title",
                                              { staticClass: "text--primary" },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.bookedLoadNickname(
                                                        txn.load
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "v-list-tile-sub-title",
                                          { staticClass: "text--primary" },
                                          [
                                            txn.load.pickup
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm._f("formatTxDate")(
                                                          txn.load.pickup.when
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ])
                                              : txn.load.tacticalInfo
                                                  .scheduledPickupTime
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm._f("formatTxDate")(
                                                          txn.load.tacticalInfo
                                                            .scheduledPickupTime
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ])
                                              : _vm._e()
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("v-list-tile-sub-title", [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(txn.loadHumanId) +
                                              ": $" +
                                              _vm._s(txn.amount) +
                                              " (" +
                                              _vm._s(txn.status || "[status]") +
                                              ")\n                  "
                                          )
                                        ])
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-list-tile-action",
                                      [
                                        _c(
                                          "v-chip",
                                          {
                                            attrs: {
                                              color: _vm.invoiceStatusIcon(txn)
                                                .color,
                                              "text-color": "white",
                                              small: ""
                                            }
                                          },
                                          [
                                            _c("v-icon", [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.invoiceStatusIcon(txn)
                                                      .icon
                                                  ) +
                                                  "\n                    "
                                              )
                                            ])
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("v-divider", {
                                  key:
                                    "delivered_load_txn_divider_" +
                                    iidx +
                                    "_" +
                                    idx +
                                    "_" +
                                    txn.id
                                })
                              ]
                            })
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("template", { slot: "detail" }, [
                _vm._v("\n        Hey there\n      ")
              ])
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12c3984c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12c3984c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/ltnplugins/approveexport/ApproveLoads.vue
// module id = null
// module chunks = 